// extracted by mini-css-extract-plugin
module.exports = {"subHero":"SubHero-module--subHero--3QNAh","title":"SubHero-module--title--2kpbl","backgroundImageWrapper":"SubHero-module--backgroundImageWrapper--32BMP"};